export default "__VITE_ASSET__CS0OOv7z__"